import {MutableRefObject, useEffect, useState} from "react";

export default function useIsInViewPort(ref: MutableRefObject<any>) {

    const [isIntersecting, setIntersecting] = useState(false);


    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => setIntersecting(entry.intersectionRatio > 0 || entry.isIntersecting)
        );
        if(ref.current) {
            observer.observe(ref.current);
        }
        return () => {
            try {
                observer.disconnect()
            } catch (err) {
                console.error('Failed to disconnect observer');
            }
        }
    }, [ref]);

    return isIntersecting;
}
